import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=7a6babcc&scoped=true"
import script from "./emptyData.vue?vue&type=script&lang=js"
export * from "./emptyData.vue?vue&type=script&lang=js"
import style0 from "./emptyData.vue?vue&type=style&index=0&id=7a6babcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6babcc",
  null
  
)

export default component.exports